import React from 'react';
import { updateUser, updateResponse, getUser, getRoles } from "../../api/userapi";
import { getAllClubs } from "../../api/clubapi";
import {
    Form,
    Label, Input,
    Button, Col, Row,
} from 'reactstrap';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import CustomDatePicker from '../CustomDatePicker';
import { formatEditDate, formatDateFields, formatInTimeZoneDate, formatInTimeZoneDateTime } from '../../helpers';
import PopupError from '../PopupError';
import CardTitle from '../CardTitle';
import FormValidator from '../FormValidation';
import cloneDeep from 'lodash/cloneDeep';
import '../css/EditCreate.css';
import InputFeedback from '../utils/InputFeedback';
import feedback from '../utils/feedback';
import RequiredFieldNotation from '../utils/RequiredFieldNotation';

class UserEdit extends React.Component {

    constructor(props) {
        super(props);
        this.props.route.history.push('/secure/users');
        this.props.route.history.push(this.props.route.match.url);
        this.validator = new FormValidator([
            {
                field: 'firstName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'lastName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'email',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            // {
            //     field: 'telephone',
            //     method: 'isEmpty',
            //     validWhen: false,
            //     message: 'Value is required.'
            // },
            // {
            //     field: 'telephone',
            //     method: this.isTelephone,
            //     validWhen: true,
            //     message: 'Must be valid phone number.'
            // },
            {
                field: 'startDate',
                method: this.isBefore,
                validWhen: true,
                message: 'Start date must be before end date.'
            },
            // {
            //     field: 'endDate',
            //     method: this.isAfter,
            //     validWhen: true,
            //     message: 'End date must be after start date'
            // }
        ])
        let user = null;
        if (this.props.route.location.user)
            if (this.props.route.location.state.user)
                user = this.props.route.location.state.user;

        this.state = {
            readOnly: true,
            user: user,
            clubs: [],
            isSupport: '',
            cancel: false,
            saved: false,
            error: false,
            edit: false,
            validation: this.validator.valid(),
            baseState: '',
            errorMessage: [],
            _startDate: '',
            _endDate: '',
            userId: this.props.route.match.params.id

        };
        this.closeModal = this.closeModal.bind(this);
    }
    isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate);
    isAfter = (confirmation, state) => (state.startDate <= confirmation);
    // isTelephone = (state) => ( state.match(/^\D?(\d{3,5})\D?\D?(\d{3,5})\D?(\d{4,5})$/) || state === "");


    //Removes the readonly attribute on edit and hides edit button / save and cancel buttons appear
    handleEdit() {
        this.setState(state => ({
            readOnly: !state.readOnly,
            edit: true,
        }));
    }

    renderClubNames() {
        let clubs = this.state.clubs;
        return clubs.map((club, index) => {
            if (club.name === this.state.clubName) {
                var selected = true;
            }
            return (
                <option id={club.clubId} key={index} defaultValue={selected}>{club.name}</option>
            );
        });
    }

    renderRoleNames() {
        let roles = this.state.roles;
        if (roles !== undefined) {
            return roles.map((role, index) => {
                if (role.role === this.state.roleName) {
                    var selected = true;
                }
                return (
                    <option id={role.roleId} defaultValue={selected} key={index}>{role.role}</option>
                );
            });
        }
    }

    componentDidMount() {
        this.props.getAllClubs(function (result, _this) { _this.getDataClubs(result, _this) }, this);
        this.props.getRoles(function (result, _this) { _this.getDataRoles(result, _this) }, this);

        if (this.state.user == null) {
            const userId = this.props.route.match.params.id;
            this.props.getUser(function (result, _this) { _this.getDataUser(result, _this) }, this, userId);
        } else if (this.props.route.location.state.user) {
            var x = JSON.stringify(cloneDeep(this.props.route.location.state.user));
            this.setState({
                baseState: x,
            });
            this.state._startDate = !this.state.user.startDate ? '' : formatInTimeZoneDate(this.state.user.startDate, '')
            this.state._endDate = !this.state.user.endDate ? '' : formatInTimeZoneDate(this.state.user.endDate, '')
        }
    }

    getDataUser(data, _this) {
        if (!this.state.user) {
            var x = JSON.stringify(cloneDeep(data.data.data))
            _this.setState({
                user: data.data.data,
                baseState: x,
                _startDate: !data.data.data.startDate ? '' : formatInTimeZoneDate(data.data.data.startDate, ''),
                _endDate: !data.data.data.endDate ? '' : formatInTimeZoneDate(data.data.data.endDate, '')
            })
        }
        if (this.state.user) {
            var isSupportstring = data.data.data.ftpNotify ? "Yes" : "No"
            this.setState({
                isSupport: isSupportstring
            });
        }
    }

    getDataClubs(data, _this) {
        _this.setState({
            clubs: data.data.data,
            loading: false
        })
    }

    getDataRoles(data, _this) {
        _this.setState({
            roles: data.data.data,
            loading: false
        })
    }


    //Resets view to previous state, goes back to view club
    handleCancel = () => {
        console.log(this.state.baseState);
        if (this.state.edit) {
            this.setState(state => ({
                readOnly: true,
                user: JSON.parse(state.baseState),
                isSupport: JSON.parse(state.baseState).ftpNotify ? "Yes" : "No",
                edit: false,
                //sets validation to previous state
                validation: this.validator.valid()
            }))

            document.getElementById("startDate").value = !this.state.user.startDate ? "" : this.state.user.startDate.substring(0, 10);
            document.getElementById("endDate").value = !this.state.user.endDate ? "" : this.state.user.endDate.substring(0, 10);
            this.submitted = false;
            //Removes the is-invalid class from all inputs when editing is canceled
            var els = document.getElementsByClassName('is-invalid')
            while (els[0]) {
                els[0].classList.remove('is-invalid')
            }

        } else {
            console.log("cancel")
            this.setState({
                cancel: true
            })
        }
    }

    closeModal() {
        this.setState({ error: false });
        this.submitted = false;
    }

    componentDidUpdate(prevProps) {
        //Checks if there is a response on update

        if (this.props.updateResult !== prevProps.updateResult) {
            var result = this.props.updateResult
            //Checks if the response is success or has errors.
            if (result) {
                if (result.data.success) {
                    var x = JSON.stringify(cloneDeep(this.state.user));
                    this.setState(state => ({
                        baseState: x,
                        saved: true,
                        edit: false,
                        readOnly: !state.readOnly,
                        validation: this.validator.valid(),
                        _startDate: !state.user.startDate ? '' : formatInTimeZoneDate(state.user.startDate + "T00:00:00", ''),
                        _endDate: !state.user.endDate ? '' : formatInTimeZoneDate(state.user.endDate + "T00:00:00", '')
                    }));

                    //When saving is success, it brings the saved results again for updating footer.
                    this.props.getUser(function (result, _this) { _this.getDataUser(result, _this) }, this, this.state.user.userId)

                } else if (result.data.success === false) {
                    var errorList = [];
                    result.data.errors.map(function (e) { errorList.push(e.message) })
                    this.setState({ error: true, errorMessage: errorList })
                }
                else {
                    let message = Object.keys(result.data.errors).map((function (e) { return 'there was an error saving ' + e }));
                    this.setState({ error: true, errorMessage: message });
                }
                this.props.updateResponse("");
            }
        }
    }

    //Calls API for updating user on form submit
    handleSubmit = event => {
        event.preventDefault();

        var updVal = this.state.user;
        updVal.startDate = document.getElementById("startDate").value;
        updVal.endDate = document.getElementById("endDate").value;
        this.setState({ user: updVal }, () => {
            const validation = this.validator.validate(this.state.user);
            this.setState({ validation });
            if (validation.isValid) {
                // handle actual form submission here
                this.props.updateUser(updVal);
            }
        });
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    render() {
        const user = this.state.user
        if (this.state.cancel) {
            return <Redirect
                to={{
                    pathname: `/secure/users`,
                }}
            />;
        }
        let validation = this.submitted ?
            this.validator.validate(this.state.user) :
            this.state.validation;

        return (
            <div className="card">

                <CardTitle
                    component={"User"}
                    readOnly={this.state.readOnly} />

                <PopupError
                    open={this.state.error}
                    onClose={this.closeModal}
                    onClick={this.closeModal}
                    errorMessage={this.state.errorMessage}
                />
                <div className="card-body fs-12">
                    {user && <Form onSubmit={this.handleSubmit}>
                        <RequiredFieldNotation />
                        <div className="row">
                            <div className="col-md-6">
                                <Col className={`${validation.lastName.isInvalid ? 'has-error' : ''}`}>
                                    <Label htmlFor='lastName' className="required-hint mt-4"><strong>Last name</strong></Label>
                                    <Input
                                        id="lastName"
                                        type="input"
                                        name="LastName"
                                        maxLength="30"
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        readOnly={this.state.readOnly}
                                        value={user.lastName}
                                        onChange={(e) => {
                                            this.isInvalid(e);
                                            var x = user;
                                            x.lastName = e.target.value;
                                            this.setState({ user: x })
                                        }}
                                    />
                                    <span className="help-block">{validation.lastName.message}</span>
                                </Col>
                                <Col className={`${validation.firstName.isInvalid ? 'has-error' : ''}`}>
                                    <Label htmlFor='firstName' className="required-hint mt-4"><strong>First name</strong></Label>
                                    <Input
                                        type="input"
                                        id='firstName'
                                        maxLength="30"
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        readOnly={this.state.readOnly}
                                        value={user.firstName}
                                        onChange={(e) => {
                                            this.isInvalid(e);
                                            var x = user; x.firstName = e.target.value; this.setState({ user: x })
                                        }} />
                                    <span className="help-block">{validation.firstName.message}</span>
                                </Col>
                                <Col className={`${validation.email.isInvalid ? 'has-error' : ''}`}>
                                    <Label htmlFor='email' className="required-hint mt-4"><strong>Email</strong></Label>
                                    <Input
                                        type="email"
                                        maxLength="320"
                                        readOnly={true}
                                        name="email"
                                        id='email'
                                        autoComplete="off"
                                        className="input-editable"
                                        value={user.email}
                                        onChange={(e) => {
                                            this.isInvalid(e);
                                            var x = user;
                                            x.email = e.target.value;
                                            this.setState({ user: x })
                                        }} />
                                    {!this.state.readOnly && <InputFeedback feedbackText={feedback.email} id='email' />}
                                    <span className="help-block">{validation.email.message}</span>
                                </Col>

                                <Col>
                                    <Label htmlFor='telephone' className="mt-4"><strong>Telephone</strong></Label>
                                    <Input
                                        type="number"
                                        name="telephone"
                                        id='telephone'
                                        readOnly={this.state.readOnly}
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        value={user.telephone}
                                        onChange={(e) => {
                                            this.isInvalid(e);
                                            const limit = 10;
                                            var x = user;
                                            x.telephone = e.target.value.slice(0, limit);
                                            this.setState({ user: x });
                                        }} />
                                    {!this.state.readOnly && <InputFeedback feedbackText={feedback.telephone} id='telephone' />}
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <Label htmlFor='clubName' className="required-hint mt-4"><strong>Club</strong></Label>
                                    <label className="select">
                                        <select
                                            id="clubName"
                                            name="clubName"
                                            value={user.clubName}
                                            disabled={this.state.readOnly}
                                            className={this.state.readOnly ? 'form-control' : 'form-control input-editable'}
                                            onChange={(e) => {
                                                var x = user;
                                                x.clubName = e.target.value;
                                                x.clubId = e.target[e.target.selectedIndex].getAttribute('id');
                                                this.setState({ user: x })
                                            }}
                                        >
                                            {this.renderClubNames()}
                                        </select>
                                    </label>
                                </Col>
                                <Col>
                                    <Label htmlFor='role' className="required-hint mt-4"><strong>Role</strong></Label>
                                    <label className="select sm-input">
                                        <select
                                            id="role"
                                            name="role"
                                            value={user.roleName}
                                            disabled={this.state.readOnly}
                                            className={this.state.readOnly ? 'form-control' : 'form-control input-editable'}
                                            onChange={(e) => {
                                                var x = user;
                                                x.roleName = e.target.value;
                                                x.roleId = e.target[e.target.selectedIndex].getAttribute('id');
                                                this.setState({ user: x })
                                            }}
                                        >
                                            {this.renderRoleNames()}
                                        </select>
                                    </label>
                                </Col>
                                <Col>
                                    <Label htmlFor='isSupport' className="mt-4"><strong>Receives FTP Notifications</strong></Label>
                                    <label className="select sm-input">
                                        <select
                                            id="isSupport"
                                            name="isSupport"
                                            value={this.state.isSupport}
                                            disabled={this.state.readOnly}
                                            className={this.state.readOnly ? 'form-control' : 'form-control input-editable'}
                                            onChange={(e) => {
                                                var x = this.state.isSupport;
                                                x = e.target.value;
                                                var y = user;
                                                y.ftpNotify = e.target[e.target.selectedIndex].getAttribute('id');
                                                this.setState({ isSupport: x, user: y })
                                            }}
                                        >
                                            <option id="true">Yes</option>
                                            <option id="false">No</option>
                                        </select>
                                    </label>
                                </Col>

                                {!this.state.readOnly && <Row>
                                    <div className="col-md-6">
                                        <Col className={`${validation.startDate.isInvalid ? 'has-error' : ''}`}>
                                            <Label htmlFor='startDate' className="mt-4"><strong>Start date</strong></Label>
                                            <CustomDatePicker
                                                id="startDate"
                                                readOnly={false}
                                                defValue={!user.startDate ? "" : formatInTimeZoneDate(user.startDate).substring(0, 10)}
                                                label="Start Date"
                                                overlayClass="location-datepicker-overlay"
                                            />
                                            <InputFeedback feedbackText={feedback.startDate} id='startDate' />
                                        </Col>
                                        <span className="help-block-calendar">{validation.startDate.message}</span>
                                    </div>
                                    <div className="col-md-6">
                                        <Col>
                                            <Label htmlFor='endDate' className="mt-4"><strong>End date</strong></Label>
                                            <CustomDatePicker
                                                id="endDate"
                                                readOnly={false}
                                                defValue={!user.endDate ? "" : formatInTimeZoneDate(user.endDate).substring(0, 10)}
                                                label="End Date"
                                                overlayClass="location-datepicker-overlay"
                                            />
                                        </Col>
                                    </div>
                                </Row>}

                                {this.state.readOnly && <div className="col-md-12">
                                    <Row>
                                        <div className={this.state.readOnly ? 'col-md-6 _startDate ' : "col-md-6 hide"}>
                                            <Label htmlFor='_startDate' className="mt-4"><strong>Start date</strong></Label>
                                            <Input
                                                id="_startDate"
                                                readOnly={true}
                                                className=''
                                                value={this.state._startDate}>
                                            </Input>

                                        </div>
                                        <div className={this.state.readOnly ? 'col-md-6 _endDate' : "col-md-6 hide"}>
                                            <Label htmlFor='_endDate' className="mt-4"><strong>End date</strong></Label>
                                            <Input
                                                id="_endDate"
                                                readOnly={true}
                                                className=''
                                                value={this.state._endDate}>
                                            </Input>
                                        </div>
                                    </Row>
                                </div>}

                                <div className="text-right float-bottom">
                                    <Button onClick={this.handleCancel.bind(this)} className="cancel-btn">CANCEL</Button>
                                    <Button onClick={this.handleEdit.bind(this)} className={this.state.readOnly ? 'edit-btn' : 'd-none'}>EDIT</Button>
                                    <Button onClick={this.handleSubmit.bind(this)} type="submit" color="primary" className={this.state.readOnly ? 'd-none' : 'save-btn'}>SAVE</Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                    }
                    <Col>
                        <hr />
                    </Col>
                    {user && <Col>
                        <Row>
                            <div className="col-md-1">
                                <div className="inline-label"><strong>ID</strong></div>
                                <p className="editFooterText">{user.userId}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Created by</strong></div>
                                <p className="editFooterText">{user.createdBy}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Created date</strong></div>
                                <p className="editFooterText">{formatInTimeZoneDateTime(user.createdDate, '')}</p>
                            </div>
                            <div className="col-md-2">
                                <div className="inline-label"><strong>Updated by</strong></div>
                                <p className="editFooterText">{user.updatedBy}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Updated date</strong></div>
                                <p className="editFooterText">{formatInTimeZoneDateTime(user.updatedDate, '')}</p>
                            </div>
                        </Row>
                    </Col>
                    }
                </div>
            </div>
        );
    }
}
export default connect(
    state => {
        return {
            user: state.data.user,
            updateResult: state.data.updateResult,
            clubs: state.data.clubs
        }
    },
    dispatch => ({
        updateUser: (callback, conext) => { dispatch(updateUser(callback, conext)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) },
        getUser: (callback, context, id) => { dispatch(getUser(callback, context, id)) },
        getRoles: (callback, context) => { dispatch(getRoles(callback, context)) },
        getAllClubs: (callback, context) => { dispatch(getAllClubs(callback, context)) }
    }
    )
)(UserEdit);

